interface Props {
  activeColor: string;
  bgColor?: string;
}

const InterestedLeadsIcon = ({ activeColor, bgColor }: Props) => {
  const fillColor = activeColor === "#0f1560" ? "#EA580C" : "#0f1560";
  const bgFillColor = bgColor ? bgColor : "#e3e9fc";

  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="24" cy="24" r="22" fill={bgFillColor} />

      <circle cx="24" cy="18" r="5" stroke="#4A4A4A" strokeWidth="2" />

      <path
        d="M14 34c0-5 4.5-9 10-9s10 4 10 9"
        stroke="#4A4A4A"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default InterestedLeadsIcon;
